import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import type { Section } from '../../../models';
import { SWIMMING_POOL } from '../../../constants';
import YesAndNo from '../../../../shared/components/Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function SwimmingPool({ section, setSectionValues }: Props) {
  function onNoSwimmingPool(): void {
    setSectionValues({
      [SWIMMING_POOL.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesSwimmingPool(): void {
    setSectionValues({
      [SWIMMING_POOL.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      label={<Label size="lg">Does the property have a swimming pool?</Label>}
      control={
        <YesAndNo
          yesHandler={onYesSwimmingPool}
          noHandler={onNoSwimmingPool}
          yesActive={section.getFieldValue(SWIMMING_POOL.FIELD_NAME.IS_ENABLED)}
        />
      }
    />
  );
}

SwimmingPool.description = 'Asks whether or not the property has a swimming pool';

export default SwimmingPool;
